module.exports = __webpack_public_path__ + "img/destination_prison_ln.c5b16a8c.jpg";